import './langswitch.css';
import { useSelector, useDispatch } from "react-redux";
import { setLang } from '../../store/langSlice';

const LangSwitch = () =>{
    const lang = useSelector((state) => state.lang.lang);
    const screen = window.screen.width;
    const dispatch = useDispatch();

    const click = (e) => {
        dispatch(setLang(e));
    }

    return(
        <div className='langSwitcher'>
            <div className='langSwitcher_label'><p>{lang === 'es'? 'idioma: ':'language: '}</p></div>
            <div className='langSwitcher_sp' onClick={()=>click('es')}>
                <img alt="language spain flag" src={`/assets/icons/${lang==='es'?'flag=cl-on.svg':'flag=cl-off.svg'}`} />
            </div>
            <div className='langSwitcher_en' onClick={()=>click('en')}>
                <img alt="language britain flag" src={`/assets/icons/${lang==='es'?'flag=brt-off.svg':'flag=brt-on.svg'}`} />
            </div>
        </div>
    )

}

export default LangSwitch;